import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Carousel } from '@beef/smart-kit';
import { useGetDimensionGroup, useIsDesktopDimension } from '@beef/ui-kit/hooks';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var SLIDES_VIEW_MOBILE = 1;
var SLIDES_VIEW_TABLET = 2;
var SLIDES_VIEW_DESKTOP = 3;
var ENABLED_CAROUSEL = 2;
export var CarouselComponent = function CarouselComponent(_ref) {
  var children = _ref.children,
    isPaginate = _ref.isPaginate,
    spaceBetween = _ref.spaceBetween,
    hasCarousel = _ref.hasCarousel,
    itemsCount = _ref.itemsCount;
  var dimension = useGetDimensionGroup();
  var isDesktop = useIsDesktopDimension();
  var getCarouselSizeView = function getCarouselSizeView() {
    if (dimension === 'mobile') {
      return SLIDES_VIEW_MOBILE;
    }
    if (dimension === 'desktop') {
      return SLIDES_VIEW_DESKTOP;
    }
    return SLIDES_VIEW_TABLET;
  };
  return !isDesktop && hasCarousel && itemsCount >= ENABLED_CAROUSEL ? /*#__PURE__*/React.createElement(Carousel, {
    className: cn('carousel'),
    settings: _objectSpread(_objectSpread({}, {
      pagination: {
        clickable: isPaginate
      },
      spaceBetween: spaceBetween
    }), {}, {
      slidesPerView: getCarouselSizeView()
    }),
    "data-t-id": "components-Carousel"
  }, children) : children;
};
CarouselComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  isPaginate: PropTypes.bool,
  spaceBetween: PropTypes.number,
  itemsCount: PropTypes.number,
  hasCarousel: PropTypes.bool
} : {};